export class BaseQueryGenerator {}
